import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { PageLoadEvent } from "@faire/retailer-visitor-shared/services/performance/const";
import { PerformanceMarker } from "@faire/retailer-visitor-shared/services/performance/PerformanceMarker";
import { useLoggedOutCategoryPageCatNavRequest } from "@faire/retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedOutCategoryPage/__internal__/DataFetching/useLoggedOutCategoryPageCatNav/__internal__/useLoggedOutCategoryPageCatNavRequest";
import { wrapAsyncFn } from "@faire/web--source/common/wrapAsyncFn";
import fetchProductCatNav from "@faire/web-api--source/api/v2/search/products/cat-nav/post";
import { getQueryKey as getQueryKeyProductCatNav } from "@faire/web-api--source/api/v2/search/products/cat-nav/post-hooks";
import { useQuery } from "@tanstack/react-query";
var STALE_TIME = 1000 * 60 * 5;
export var useLoggedOutCategoryPageCatNavResponse = function() {
    var request = useLoggedOutCategoryPageCatNavRequest();
    var _useQuery = useQuery({
        queryKey: getQueryKeyProductCatNav(request),
        queryFn: function(param) {
            var signal = param.signal;
            return wrapAsyncFn(function() {
                return fetchProductCatNav(request, {
                    signal: signal
                });
            }, {
                after: function() {
                    PerformanceMarker.get().mark(PageLoadEvent.primaryFetchEnd);
                }
            });
        },
        staleTime: STALE_TIME
    }), response = _useQuery.data, isFetching = _useQuery.isFetching, error = _useQuery.error, dataUpdatedAt = _useQuery.dataUpdatedAt;
    var data = setProductFirstResponseInformation(response);
    return {
        data: data,
        error: error,
        isFetching: isFetching,
        dataUpdatedAt: dataUpdatedAt
    };
};
var setProductFirstResponseInformation = function(response) {
    var _response_product_tiles, _response_pagination_data, _response_more_in_c3, _response_more_in_c31;
    var productFirstSearchResults = response === null || response === void 0 ? void 0 : (_response_product_tiles = response.product_tiles) === null || _response_product_tiles === void 0 ? void 0 : _response_product_tiles.map(function(productTile) {
        var _productTile_product;
        var _productTile_product_brand_token;
        var brand = response === null || response === void 0 ? void 0 : response.brand_by_token[(_productTile_product_brand_token = (_productTile_product = productTile.product) === null || _productTile_product === void 0 ? void 0 : _productTile_product.brand_token) !== null && _productTile_product_brand_token !== void 0 ? _productTile_product_brand_token : ""];
        return _object_spread_props(_object_spread({}, productTile), {
            brand: brand
        });
    });
    var _response_formatted_total_primary_results_count, _response_related_search_terms, _response_more_in_c3_more_in_c3_terms;
    return {
        productFirstSearchResults: productFirstSearchResults,
        requestId: response === null || response === void 0 ? void 0 : response.request_id,
        paginationData: response === null || response === void 0 ? void 0 : response.pagination_data,
        pageCount: (response === null || response === void 0 ? void 0 : (_response_pagination_data = response.pagination_data) === null || _response_pagination_data === void 0 ? void 0 : _response_pagination_data.page_count) || 0,
        totalPrimaryResultsCount: (_response_formatted_total_primary_results_count = response === null || response === void 0 ? void 0 : response.formatted_total_primary_results_count) !== null && _response_formatted_total_primary_results_count !== void 0 ? _response_formatted_total_primary_results_count : "",
        brandPageQueryParams: response === null || response === void 0 ? void 0 : response.brand_page_query_parameters,
        relatedSearchTerms: (_response_related_search_terms = response === null || response === void 0 ? void 0 : response.related_search_terms) !== null && _response_related_search_terms !== void 0 ? _response_related_search_terms : [],
        moreInC3CategoryName: response === null || response === void 0 ? void 0 : (_response_more_in_c3 = response.more_in_c3) === null || _response_more_in_c3 === void 0 ? void 0 : _response_more_in_c3.more_in_c3_category_name,
        moreInC3Terms: (_response_more_in_c3_more_in_c3_terms = response === null || response === void 0 ? void 0 : (_response_more_in_c31 = response.more_in_c3) === null || _response_more_in_c31 === void 0 ? void 0 : _response_more_in_c31.more_in_c3_terms) !== null && _response_more_in_c3_more_in_c3_terms !== void 0 ? _response_more_in_c3_more_in_c3_terms : []
    };
};
